<!-- @format -->

@if (buttonText()) {
	@if (
		!nearbyStoresButtonEnabled() ||
		buttonText().addToCartButtonText !== atcButtonTexts.nearbyStores
	) {
		@if (showQuantityInput()) {
			<input
				id="pdp-input-qty"
				#userInputQty
				class="hmf-sharp-radius hmf-header-bold-s hmf-text-align-center"
				type="number"
				maxlength="2"
				[min]="minQty()"
				[max]="maxQty()"
				aria-label="Quantity"
				[ngModel]="userInputQuantity()"
				(ngModelChange)="userInputQuantity.set($event)"
				(keyup.enter)="validateQuantity(userInputQty.value)"
				(blur)="validateQuantity(userInputQty.value)" />
		}
		@let buttonClasses = 'hmf-flex-grow hmf-p-0 hmf-mr-0';
		<button
			hmf-button
			[attr.aria-label]="buttonText().addToCartButtonText"
			variant="primary"
			id="pdp-add-to-cart-button"
			[class]="buttonClasses"
			type="submit"
			[disabled]="
				isErrorOnAttributes()
					? true
					: buttonText().addToCartButtonDisabled ||
						disabled() ||
						(buttonText().addToCartButtonText === atcButtonTexts.noStoreSelected &&
							!storeSelectionReady())
			"
			[text]="buttonText().addToCartButtonText"
			(click)="
				addToCartButtonClicked(buttonText().addToCartButtonText, buttonText().buttonAction)
			"></button>
	}
	@if (
		nearbyStoresButtonEnabled() &&
		buttonText().addToCartButtonText === atcButtonTexts.nearbyStores
	) {
		<pdp-add-to-cart-see-available-stores-button></pdp-add-to-cart-see-available-stores-button>
	}
}
